import { ReactComponent as GenericaIcon } from '../../../../../../assets/iconosVinculaciones/17.svg'
import { ReactComponent as RendicionesIcon } from '../../../../../../assets/iconosVinculaciones/5.svg'
import { ReactComponent as GastosCIcon } from '../../../../../../assets/iconosVinculaciones/3.svg'
import { ReactComponent as ArriendosIcon } from '../../../../../../assets/iconosVinculaciones/2.svg'
import AddIcon from '@mui/icons-material/Add'

export const getVinculacionTemplate = item => {
  const folio = item?.folioCredito
  if (folio == null || String(folio).trim() === '') return undefined
  return IconosPlan.find(template => template.foliosCredito?.includes(Number(folio)))
}

export const VinculacionIcon = ({ item, className = 'h-8 w-8' }) => {
  const template = getVinculacionTemplate(item)
  const Icon = template?.icon ?? GenericaIcon
  return <Icon className={className} role='img' aria-label={template?.title ?? 'Vinculación'} />
}

export const IconosPlan = [
  {
    icon: GastosCIcon,
    title: 'Gastos Comunes',
    foliosCredito: [2],
    id: '3',
    tooltipText: 'Registro de pagos periodicos asociados a administracion, mantencion y servicios compartidos de un edificio o condominio.'
  },
  {
    icon: ArriendosIcon,
    title: 'Pago Arriendos',
    foliosCredito: [0],
    id: '5',
    tooltipText: 'Registro del gasto por arrendamiento de un bien raiz u otro activo utilizado por la empresa.'
  },
  {
    icon: ArriendosIcon,
    title: 'Cobro Arriendos',
    foliosCredito: [1],
    id: '6',
    tooltipText: 'Registro del ingreso obtenido por arrendar un bien raiz u otro activo de la empresa.'
  },
  {
    icon: ArriendosIcon,
    title: 'Cobro Masivo',
    id: '19',
    tooltipText: 'Permite gestionar de forma conjunta varios documentos pendientes de cobro. Disponible solo para Caja Principal.'
  },
  {
    icon: ArriendosIcon,
    title: 'Pago Masivo',
    id: '20',
    tooltipText: 'Permite gestionar de forma conjunta varios documentos pendientes de pago. Disponible solo para Caja Principal.'
  },
  {
    icon: RendicionesIcon,
    title: 'Retiro Dividendo',
    foliosCredito: [3],
    id: '7',
    tooltipText: 'Registro del dinero o beneficios que socios o accionistas retiran de la empresa como distribucion de utilidades.'
  },
  {
    icon: RendicionesIcon,
    title: 'Prestamo Otorgado',
    foliosCredito: [4, 5],
    id: '8',
    tooltipText: 'Registro del dinero entregado por la empresa a un tercero en calidad de prestamo.'
  },
  {
    icon: RendicionesIcon,
    title: 'Credito Consumo',
    foliosCredito: [6, 7],
    id: '9',
    tooltipText: 'Registro del dinero ingresado a la empresa proveniente de un prestamo otorgado por un tercero.'
  },
  {
    icon: RendicionesIcon,
    title: 'Aporte Transitorio Socio',
    foliosCredito: [10],
    id: '10',
    tooltipText: 'Registro del dinero que un socio entrega temporalmente a la empresa para apoyarla financieramente.'
  },
  {
    icon: RendicionesIcon,
    title: 'Patente Comercial',
    foliosCredito: [8],
    id: '11',
    tooltipText: 'Registro del gasto realizado para cumplir con el pago obligatorio que habilita a la empresa a ejercer su actividad comercial.'
  },
  {
    icon: RendicionesIcon,
    title: 'Contribuciones',
    foliosCredito: [9],
    id: '12',
    tooltipText: 'Registro del gasto correspondiente al impuesto territorial por la propiedad de bienes raices.'
  },
  {
    icon: AddIcon,
    title: 'Otras',
    id: '13a'
  },
  {
    icon: AddIcon,
    title: 'Otras',
    id: '13b'
  },
  {
    icon: AddIcon,
    title: 'Otras',
    id: '13c'
  },
  {
    icon: GastosCIcon,
    title: 'Devolucion Aporte Transitorio',
    foliosCredito: [11],
    id: '16',
    tooltipText: 'Registro del pago realizado a un socio para devolver dinero entregado temporalmente a la empresa.'
  },
  {
    icon: GastosCIcon,
    title: 'Rendicion de Gastos',
    foliosCredito: [12],
    id: '17',
    tooltipText: 'Registro de la devolucion o reembolso de dinero a un trabajador o colaborador por gastos realizados en nombre de la empresa.'
  },
  {
    icon: GastosCIcon,
    title: 'Invoice Compra',
    foliosCredito: [13],
    id: '18',
    tooltipText: 'Registro de una factura emitida por un proveedor extranjero a la empresa por la adquisicion de bienes o servicios.'
  },
  {
    icon: GastosCIcon,
    title: 'Invoice Importaciones',
    foliosCredito: [35],
    id: '38',
    tooltipText: 'Registro de una invoice asociada a importaciones.'
  },
  {
    icon: GastosCIcon,
    title: 'Anticipo Agente de Aduana',
    foliosCredito: [27],
    id: '28',
    tooltipText: 'Registro de un anticipo entregado a un agente de aduana.'
  },
  {
    icon: GastosCIcon,
    title: 'Devolución Agente Aduana',
    foliosCredito: [30],
    id: '34',
    tooltipText: 'Registro de la devolución de un anticipo por parte de un agente de aduana.'
  },
  {
    icon: GastosCIcon,
    title: 'Anticipo Sueldo',
    foliosCredito: [28],
    id: '29',
    tooltipText: 'Registro asociado a un anticipo de sueldo.'
  },
  {
    icon: GastosCIcon,
    title: 'Cuenta Corriente Agente de Aduana',
    id: '32',
    tooltipText: 'Registro de una provisión asociada a los servicios y gastos de un agente de aduana.'
  },
  {
    icon: RendicionesIcon,
    title: 'Aporte Empresa Relacionada',
    foliosCredito: [33],
    id: '35',
    tooltipText: 'Registro de un aporte entregado a una empresa relacionada.'
  },
  {
    icon: RendicionesIcon,
    title: 'Devolución Empresa Relacionada',
    foliosCredito: [34],
    id: '36',
    tooltipText: 'Registro de una devolución recibida desde una empresa relacionada.'
  },
  {
    icon: RendicionesIcon,
    title: 'Cuenta Corriente Empresa Relacionada',
    id: '37',
    tooltipText: 'Cuenta corriente asociada a movimientos con empresas relacionadas.'
  },
  {
    icon: GenericaIcon,
    title: 'Cargo Generico',
    foliosCredito: [25],
    id: '30',
    tooltipText: 'Formulario generico para crear vinculaciones de cargo y escoger el tipo contable desde un solo modal.'
  },
  {
    icon: GenericaIcon,
    title: 'Abono Generico',
    foliosCredito: [26],
    id: '31',
    tooltipText: 'Formulario generico para crear vinculaciones de abono y escoger el tipo contable desde un solo modal.'
  },
  {
    icon: GastosCIcon,
    title: 'Invoice Venta',
    foliosCredito: [14],
    id: '21',
    tooltipText: 'Registro de una factura emitida a un cliente extranjero por la venta de bienes o servicios.'
  },
  {
    icon: GastosCIcon,
    title: 'Finiquitos',
    foliosCredito: [15],
    id: '22'
  },
  {
    icon: GastosCIcon,
    title: 'Multas',
    foliosCredito: [29],
    id: '33',
    tooltipText: 'Registro de cargos asociados al pago de multas.'
  },
  {
    icon: GastosCIcon,
    title: 'Inversiones',
    foliosCredito: [16, 17, 18],
    id: '23'
  },
  {
    icon: GastosCIcon,
    title: 'Valores Negociables',
    foliosCredito: [19, 20, 21],
    id: '24'
  },
  {
    icon: RendicionesIcon,
    title: 'Ajuste de Existencias',
    foliosCredito: [22],
    id: '25'
  },
  {
    icon: GastosCIcon,
    title: 'Provision de fondo Cliente',
    id: '26'
  },
  {
    icon: GastosCIcon,
    title: 'Provision de fondo Proveedores',
    id: '27'
  },
    {
    icon: RendicionesIcon,
    title: 'Devolución de Impuestos',
    foliosCredito: [36],
    id: '39',
    tooltipText: 'Registro de una devolución de impuestos de Servicios Impuestos Internos.'
  },
]
